export default __webpack_public_path__ + "static/media/ibrahim1.fad161ff.jpeg";